import { render } from "./TabHeader.vue?vue&type=template&id=5314e0cf"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"
script.render = render

export default script